/**
 * Required by the licence, and shown on every surface that stands alone.
 * See NOTICE at the repository root.
 */
export function Attribution() {
  return (
    <footer className="attribution">
      <span className="attribution__author">
        made by{' '}
        <a href="https://github.com/L4UZ" target="_blank" rel="noreferrer">
          L4UZ
        </a>
      </span>
      Based on{' '}
      <a href="https://www.secrethitler.com" target="_blank" rel="noreferrer">
        Secret Hitler
      </a>{' '}
      by Mike Boxleiter, Tommy Maranges and Mac Schubert, licensed under{' '}
      <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noreferrer">
        CC BY-NC-SA 4.0
      </a>
      . This is a non-commercial digital adaptation for in-person play, released under the same
      licence. Board icons from{' '}
      <a href="https://game-icons.net" target="_blank" rel="noreferrer">
        game-icons.net
      </a>{' '}
      (
      <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noreferrer">
        CC BY 3.0
      </a>
      ) by Lorc and Delapouite; seat icons from{' '}
      <a href="https://phosphoricons.com" target="_blank" rel="noreferrer">
        Phosphor
      </a>{' '}
      (MIT).
    </footer>
  )
}
